import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import moment from 'moment';
import 'moment/locale/es';

const CardNotification = ({ notificaciones }) => {
  const [isHovered, setIsHovered] = useState(false);

  const fecha = moment(notificaciones.created_at).locale('es').format('DD/MM/YYYY ~ HH:mm');

  const handleHover = () => {
    setIsHovered(!isHovered);
  };

  return (
    <div style={{ marginLeft: '6rem' }}>
      <div className="title-notification">
        <p>Notificaciones</p>
      </div>
      <div className="container-notification">
        {notificaciones.map((notificacion) => (
          <div
            className={`card-notification ${isHovered ? 'card-notification--hovered' : ''}`}
            onMouseEnter={handleHover}
            onMouseLeave={handleHover}
            key={notificacion.id}
          >
            <div className="img-notification">
              <img src={`${process.env.REACT_APP_BACKEND_URL}${notificacion.imagen_url}`} alt="cacho" />
            </div>
            <div className="container-description-notification">
              <h3>{notificacion.titulo}</h3>
              <p>{fecha}</p>
            </div>
            <p className="description">{notificacion.descripcion}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

CardNotification.propTypes = {
  notificaciones: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      imagen_url: PropTypes.string.isRequired,
      titulo: PropTypes.string.isRequired,
      created_at: PropTypes.string.isRequired,
      descripcion: PropTypes.string.isRequired,
    })
  ).isRequired,
};
export default CardNotification;
